export default "__VITE_ASSET__CGHSTTEx__"